export function responsiveContentfulSrcset(props: { url: string }) {
  const { url } = props;
  if (!url) return '';
  return [
    `${url}?w=375&q=90&fm=webp 375w,`,
    `${url}?w=500&q=90&fm=webp 500w,`,
    `${url}?w=768&q=90&fm=webp 768w,`,
    `${url}?w=1024&q=90&fm=webp 1024w,`,
    `${url}?w=1440&q=90&fm=webp 1440w,`,
    `${url}?w=1920&q=90&fm=webp 1920w,`,
    `${url}?w=2560&q=90&fm=webp 2560w,`,
    `${url}?w=3840&q=90&fm=webp 3840w`,
  ].join(' ');
}
